"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTranslations = void 0;
var _alloyReactHelpers = require("@adsk/alloy-react-helpers");
var _uniq = _interopRequireDefault(require("lodash/uniq"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const defaultLanguage = "en";
// We want to support more languages than Alloy provides at the moment.
// https://jira.autodesk.com/browse/SCCOM-9438
const extendedSupportedLocales = (0, _uniq.default)([..._alloyReactHelpers.supportedLocales, ...["cht", "cs", "da", "de", "en", "en-GB", "es", "fr", "fr-CA", "it", "ja", "ko", "nl", "pl", "pt-BR", "ru", "sv", "zh-Hans", "zh-Hant-HK"]]);
const useTranslations = () => (0, _alloyReactHelpers.useLocale)(_ref => {
  let {
    locale
  } = _ref;
  return extendedSupportedLocales.includes(locale) ? require("../../i18n/".concat(locale, ".json")) : require("../../i18n/".concat(defaultLanguage, ".json"));
});
exports.useTranslations = useTranslations;
//# sourceMappingURL=useTranslations.js.map